<template>

    <div class="listlayout"  id="rptListBox">

        <el-tabs v-model="activeName" type="card"  >
            <el-tab-pane :label="$t('report.myreport')" name="rpt" :key="1">
                <el-tree ref="customTree"    :data="rptList"
                         :element-loading-text="$t('tips_data_loading_in_progress')" :props="nodeProps"
                         node-key="id" highlight-current   @node-click="handleNodeClick">
                </el-tree>
            </el-tab-pane>
        </el-tabs>

    </div>


</template>
<script>
    import { mapGetters } from "vuex";
    import $ from 'jquery';
    import languages from '../lang/languages.js';
    export default {
        name: "reportList",


        data(){

            return {
                rptType:[],
                rptList:[],
                activeName:"rpt",
                rptInfo:{},
                currentNode:{},
                nodeProps: { children:false, label: "label", isLeaf: "leaf" },
                focusObj:{},

            }
        },
        watch: {
            rptList: {

                handler(n, o) {
                    this.rptList=n;

                },
                deep:true
            },
        },

        mounted() {
            let lang=sessionStorage.getItem("vc_lang");
            this.$i18n.mergeLocaleMessage(lang, languages[lang]);
            this.rptType=[{id:1,type:'rpt',label:this.$t('report_inventory_report')},
                {id:2,type:this.$t('report_business'),label:this.$t('report_business_report')},
                {id:3,type:this.$t('report_finance'),label:this.$t('report_financial_statements')}];
                this.$emit('loadRptList');
        },
        methods: {


            setRptList(data){
                this.rptList=data;
            },
            handleNodeClick(e,node,item) {
                this.currentNode=node.data;
                this.$emit('handleNodeClick', node.data);

            },
            treeNodeClick(data,item) {
                item.value=data.id;
                item.label=data.name;
                let selectTree=`${item.name}_select`;
                this.$refs[selectTree][0].blur();
            },

            selectRptNode(id){
                this.$nextTick(() => {
                 this.$refs.customTree.setCurrentKey(id); // 设置id为的节点为选中状态
                 this.$emit('handleNodeClick', this.$refs.customTree.getCurrentNode());

                 });
            },
            inputfocus(a){
                a.target.select();
            },
            scrollToNode() {


                this.$nextTick(()=>{    // 获取高亮节点
                    const tree = this.$refs.customTree;
                      let highlightNode = tree.$el.querySelectorAll('.el-tree--highlight-current .el-tree-node.is-current>.el-tree-node__content');
                         if(highlightNode && highlightNode.length){        highlightNode[0].scrollIntoView(50);
                         }});


            },


            filterOption(value){
              //  if (!value) return true;
                let treename=`${this.focusObj.name}_tree`;
               this.$refs[treename][0].filter(value);
            },
            selectFocus(item){
                      this.focusObj=item;
                 },
            filterTreeNode(value, data) {
                if (!value) return true;
                if (data.name == undefined) {
                    return data.label.indexOf(value) !== -1;
                } else {
                    return data.name.indexOf(value) !== -1 ;
                }
            },


            setTreeItem(data){
                let _this=this;
                let newdata=[];
                $.each(data, function (key, item) {
                    if (data.filter(obj => obj.id==item.pid).length==0)
                    {  item['children']=[];
                        item=_this.setTreeChild(item,data);
                        newdata.push(item);}
                });
                return newdata;
            },
            setTreeChild(p,data){
                let _this=this;
                let childItem=data.filter(obj => obj.pid==p.id)
                $.each(childItem, function (key, item) {
                    item['children']=[];
                    item=_this.setTreeChild(item,data);
                    p.children.push(item);
                });
                return p;
            },



        }
    };


</script>

<style lang="scss" >


    .listlayout {
        height: 100%;
        width: 260px;
            /*flex: 1;*/
            position: relative;
             overflow: hidden;
        .el-tabs {
            width: 260px;
            height: calc(100%);
            border: 0px solid #267b87;
            .el-tabs__header {
                /*height: 36px;*/
                margin: 0;
                padding: 0px;
            }
            .el-tabs-card {
                margin: 0;
                padding: 0;
                width: 100%;
                height: 34px;


            }

       }
            .el-tabs__item.is-active {
                color: #774917;
                background-color: #a9e0ea; //修改背景色
            }

            .el-tabs__content {
                margin: 0;
                padding: 0px;
                border: 0px solid #267b87;
                height: calc(100% - 36px);
                overflow: auto;
            }

        .parm_item
            {   padding: 0px 0px;
                margin: 0px;
                height: 32px;
                position: relative;
                float: left;
                width: 180px;
            }

    }
</style>
